/**
 * The raised, coloured icon tile used by the student and parent sidebars.
 *
 * Each menu item keeps its own colour (they already carry `color` / `gradient`), so the menu
 * reads at a glance instead of being one purple column. Idle: a soft tint of that colour
 * with a light top edge and a drop shadow, so the tile looks lifted. Selected: the row is
 * already painted with the item's gradient, so the tile turns to frosted white.
 */
const FALLBACK = "#667eea";

export const navIconTileSx = (color = FALLBACK, active = false, size = 32) => {
  const c = color || FALLBACK;
  return {
    width: size,
    height: size,
    borderRadius: `${Math.round(size * 0.32)}px`,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: active ? "#fff" : c,
    background: active
      ? "rgba(255,255,255,0.22)"
      : `linear-gradient(145deg, ${c}2e 0%, ${c}12 100%)`,
    boxShadow: active
      ? "inset 0 1px 0 rgba(255,255,255,0.35), 0 2px 6px rgba(0,0,0,0.18)"
      : `inset 0 1px 0 rgba(255,255,255,0.9), 0 3px 7px ${c}40`,
    border: active ? "1px solid rgba(255,255,255,0.35)" : `1px solid ${c}26`,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  };
};

/** Hover lift for the row that holds the tile: `"&:hover .nav-icon-tile": navIconTileHoverSx(color)`. */
export const navIconTileHoverSx = (color = FALLBACK) => ({
  transform: "translateY(-1px) scale(1.06)",
  boxShadow: `inset 0 1px 0 rgba(255,255,255,0.9), 0 6px 12px ${(color || FALLBACK)}55`,
});
